import SystemHeader from 'components/Headers/UserHeader';
import { Notification } from 'notification/notification';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { useSale } from 'views/system/Sale/sale-table-context';

export const CustomForm = (props) => {
  const [double, setDouble] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  let history = useHistory();
  const { setData } = useSale();
  const {
    nameForm,
    typeForm,
    toRedirect,
    onlyReturnPage,
    getValues,
    pathUrl,
    loadValues,
    forceRefreshPage,
    disableSave,
    forceRefreshState,
    skipForceRefreshPage,
  } = props;

  useEffect(() => {
    async function getData() {
      if (id !== undefined && id !== 'new') {
        if (location.state === undefined) {
          const response = await handleSendGeneric(pathUrl + '/' + id, 'GET');
          loadValues(response);
          return;
        } else if (forceRefreshState) {
          const response = await handleSendGeneric(pathUrl + '/' + id, 'GET');
          loadValues(response);
          return;
        }
        loadValues(location.state);
      }
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadValues, id, pathUrl, location]);

  const handleChangeEntity = async () => {
    try {
      setDouble(true);
      let data;
      if (typeof getValues === 'function') {
        data = getValues();
      } else {
        data = getValues;
      }
      const newData = data.id === null;
      const response = await handleSendGeneric(pathUrl, typeForm, data);
      console.log(response);
      if (response.status === 200 && '/admin/sale/pre-sale/' === toRedirect) {
        Notification(200, 'Dados salvos com sucesso!');
        setData([]);
      }
      if (response.status === 200) {
        if (skipForceRefreshPage && typeForm === 'POST') {
          Notification(
            200,
            newData
              ? 'Dados salvos com sucesso!'
              : 'Dados atualizado com sucesso!',
          );
          window.location.reload();
          return;
        }

        if (forceRefreshPage && typeForm === 'POST') {
          Notification(
            200,
            newData
              ? 'Dados salvos com sucesso!'
              : 'Dados atualizado com sucesso!',
          );
          history.push(toRedirect + response.data.id, response.data);
          return;
        }
        history.push(toRedirect, response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDouble(false);
    }
  };

  const handleReturnPage = () => {
    onlyReturnPage ? history.goBack() : history.push(toRedirect);
  };

  return (
    <>
      <SystemHeader />
      <Container className='mt--7' fluid>
        <Row>
          <Col className='order-xl-1' xl=''>
            <Card className='bg-white shadow'>
              <CardHeader className='bg-white border-0'>
                <Row className='align-items-center'>
                  <Col xs='8'>
                    <h3 className='mb-0' style={{ fontSize: '18px' }}>
                      {nameForm}
                    </h3>
                  </Col>
                  <Col className='text-right' xs='4'>
                    <Button color='dark' onClick={handleReturnPage} size='md'>
                      Voltar
                    </Button>
                    {disableSave ? null : (
                      <Button
                        color='primary'
                        onClick={handleChangeEntity}
                        size='md'
                        disabled={double}
                      >
                        Salvar
                      </Button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>{props.children}</CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
